var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6751 7.62571C24.6504 0.531368 13.8198 2.71436 10.28 7.43934C6.74023 12.1643 16.6518 15.1466 20.249 22.5132C25.1001 32.4477 38.2061 16.4936 30.6751 7.62571Z",
    fill: "#001F4B",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9958_54659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 28C5.46667 28 5 27.8 4.6 27.4C4.2 27 4 26.5333 4 26V6C4 5.46667 4.2 5 4.6 4.6C5 4.2 5.46667 4 6 4H26C26.5333 4 27 4.2 27.4 4.6C27.8 5 28 5.46667 28 6V26C28 26.5333 27.8 27 27.4 27.4C27 27.8 26.5333 28 26 28H6ZM6 26H26V6H6V26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 17C20.9902 17 22.3334 15.6569 22.3334 14C22.3334 12.3431 20.9902 11 19.3334 11C17.6765 11 16.3334 12.3431 16.3334 14C16.3334 15.6569 17.6765 17 19.3334 17Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3334 20C23.3334 20.5523 22.8856 21 22.3334 21H16.3334C15.7811 21 15.3334 20.5523 15.3334 20C15.3334 19.4477 15.7811 19 16.3334 19H22.3334C22.8856 19 23.3334 19.4477 23.3334 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66663 30.0003C9.11436 30.0003 8.66663 29.5526 8.66663 29.0003V27.667C8.66663 27.1147 9.11436 26.667 9.66663 26.667C10.2189 26.667 10.6666 27.1147 10.6666 27.667V29.0003C10.6666 29.5526 10.2189 30.0003 9.66663 30.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 20.333C7.99996 20.8853 7.55223 21.333 6.99996 21.333H5.66663C5.11434 21.333 4.66663 20.8853 4.66663 20.333C4.66663 19.7807 5.11434 19.333 5.66663 19.333H6.99996C7.55223 19.333 7.99996 19.7807 7.99996 20.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 11C7.99996 11.5523 7.55223 12 6.99996 12H5.66663C5.11434 12 4.66663 11.5523 4.66663 11C4.66663 10.4477 5.11434 10 5.66663 10H6.99996C7.55223 10 7.99996 10.4477 7.99996 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3334 30.0003C21.7811 30.0003 21.3334 29.5526 21.3334 29.0003V27.667C21.3334 27.1147 21.7811 26.667 22.3334 26.667C22.8856 26.667 23.3334 27.1147 23.3334 27.667V29.0003C23.3334 29.5526 22.8856 30.0003 22.3334 30.0003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9958_54659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesVault);
export default __webpack_public_path__ + "static/media/features-vault.aca1a9f9.svg";
export { ForwardRef as ReactComponent };